<template>
  <div class="container cont">
  <div class="login-form">
    <div class="entrada shadow">
		<img id="senfulogo" src="../assets/svg/senfu-favicon.svg" alt="SENFU México">
		<h1 class="titulo">ALMACÉN</h1>
		<vs-input
      class="shadow"
      name="email"
      icon="icon icon-user"
      icon-pack="feather"
      label-placeholder="Email"
      v-model="email"
      size="large"
      placeholder="Usuario" />

		<vs-input
      class="shadow"
      type="password"
      name="password"
      icon="icon icon-lock"
      icon-pack="feather"
      label-placeholder="Password"
      v-model="password"
      size="large" />
		<vs-button
      class="entrar"
      color="primary"
      type="filled"
      v-on:click="login"
    >
      ENTRAR
    </vs-button>
    </div>
  <the-footer
    class="sombra">
  </the-footer>
  </div>
</div>
</template>

<script>
  // const firebase = require('../firebase/firebaseConfig');
  import TheFooter from '../layouts/components/TheFooter.vue';
  import firebase from 'firebase/app';

  export default {
    name: 'login',
    data(){
      return {
        email:'',
        password:''
      }
    },
    methods: {
      login: function (e) {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(user => {
              // alert('Estás conectado como ${user.email}');
              //alert('ESTÁS CONECTADO');
              this.$router.push('/');
            },
            err => {
              alert(err.message);
            });

        console.log('login');
        e.preventDefault();
      }
    },
    components: {
       TheFooter
  },
  }
</script>

<style scoped>


.entrar {
  margin: 20px 0 0 0;
}

 /* Repetido */

.the-footer {
     -webkit-box-align: center;
     align-items: center;
     background-image: linear-gradient(0deg,#003385 0%,#0d62e6 100%);
     bottom: 0;
     box-shadow: rgba(0,0,0,.05) 0 4px 20px 0;
     box-sizing: border-box;
     display: block;
     margin: 0;
     outline: none;
     padding: 1rem 2.2rem;
     position: fixed;
     text-align: center;
     text-decoration: none;
     text-transform: none;
     width: 100%;
     z-index: 40000;
   }

</style>
